export const rationalNumbers = {
  mask: Number,
  scale: 2,
  signed: true,
  radix: ',',
  min: 0,
  max: 10000000000,
  thousandsSeparator: ' ',
  mapToRadix: ['.'],
  normalizeZeros: true,
  unmask: 'typed'
}
